import { BaseAgent } from 'agents';
import SubscriptionAgent from './subscription';

const CatalogAgent = {
    categories: (coupon) =>
        Promise.all([
            BaseAgent.get(
                `/payment/catalog${coupon ? `?coupon=${coupon}` : ''}`,
            ),
            coupon
                ? SubscriptionAgent.retrieveCoupon(coupon).catch(() => null)
                : null,
        ]).then(([categories, retrievedCoupon]) => {
            return {
                ...categories,
                coupon: retrievedCoupon,
            };
        }),
    previews: (plans, coupon) =>
        BaseAgent.post('/payment/web/upgrade/previews', {
            plans,
            code: coupon,
        }),
    plans: (plans = []) =>
        BaseAgent.get(`/payment/plans?ids=${plans.join(',')}`),
};

export default CatalogAgent;
